/** 차량 이야기 탭별 마지막 방문 시각 저장 키 (값: latestPublishedAt ISO 문자열) */
export const CAR_STORY_LAST_VISITED_STORAGE_KEY = 'carStory:lastVisitedByMenu'
